import React from "react";
import { IoCalendar } from "react-icons/io5";
import DatePicker2 from "./ui/DatePicker2";

/**
 * DateRangePicker
 *
 * Supports two prop patterns:
 *
 * Pattern A – unified (preferred):
 *   <DateRangePicker value={{ from, to }} onChange={fn} />
 *
 * Pattern B – split (legacy / BookedOrders):
 *   <DateRangePicker
 *     startDate={from}  endDate={to}
 *     onStartDateChange={setFrom}  onEndDateChange={setTo}
 *   />
 *
 * Both patterns resolve to the same internal { from, to } / onChange contract
 * that DatePicker2 expects.
 */
const DateRangePicker = ({
  // Pattern A
  value,
  onChange,
  // Pattern B (legacy aliases)
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  // Shared props
  className = "",
  showYearDropdown = true,
  showTimePicker = false,
  allowFuture = true,
  allowPast = true,
  minDate,
  maxDate,
  excludedDates = [],
  maxSelectableRange,
}) => {
  // Reconcile both prop patterns into a single { from, to } value
  const resolvedValue =
    value !== undefined
      ? value
      : startDate !== undefined || endDate !== undefined
      ? { from: startDate, to: endDate }
      : undefined;

  // Reconcile both onChange patterns
  const resolvedOnChange = (range) => {
    if (onChange) {
      onChange(range);
    }
    if (onStartDateChange || onEndDateChange) {
      onStartDateChange?.(range?.from ?? null);
      onEndDateChange?.(range?.to ?? null);
    }
  };

  return (
    <div
      className={`flex items-center shrink-0 grow-0 gap-2 bg-background_2/80 p-1 pl-2 pr-1.5 min-h-12 rounded-2xl  ${className}`}
    >
      {/* Calendar Icon */}
      <IoCalendar className="text-secondary text-xl" />
      <DatePicker2
        mode="range"
        placeholder="Select From & To Date"
        value={resolvedValue}
        onChange={resolvedOnChange}
        showYearDropdown={showYearDropdown}
        showTimePicker={showTimePicker}
        allowFuture={allowFuture}
        allowPast={allowPast}
        minDate={minDate}
        maxDate={maxDate}
        excludedDates={excludedDates}
        maxSelectableRange={maxSelectableRange}
      />
    </div>
  );
};

export default DateRangePicker;
